import React from 'react';
import InternalPortal from './internal/components/internal-portal';
import useIsSubsequentRender from './internal/hooks/use-is-subsequent-render';
import useFirePortalEvent from './internal/hooks/use-portal-event';
export default function Portal(_ref) {
  var _ref$zIndex = _ref.zIndex,
    zIndex = _ref$zIndex === void 0 ? 0 : _ref$zIndex,
    children = _ref.children,
    _ref$mountStrategy = _ref.mountStrategy,
    mountStrategy = _ref$mountStrategy === void 0 ? 'effect' : _ref$mountStrategy;
  var isSubsequentRender = useIsSubsequentRender(mountStrategy);
  useFirePortalEvent(zIndex);
  return isSubsequentRender ? /*#__PURE__*/React.createElement(InternalPortal, {
    zIndex: zIndex
  }, children) : null;
}